import { alpha, createTheme } from "@material-ui/core";
import { TenantSettings, AllApplicationsActions } from "../..";
import { DployThemeOptions } from "../../dployTheme";
import SharpSans from "../../fonts/SharpSans";

const brageStaticTextColorForAllBrandsAndThemes = "#00002b";
export const themeObject: DployThemeOptions = {
	/*
	Primary colors:
	- Brage Rød 		- #DA0D2B - 218 13 43
	- Brage Mørkeblå 	- #00002B - 0 0 43
	- Brage Krem		- #FDF8F1 - 253 248 241
	- Hvit				- #FFFFFF - 255 255 255

	Secondary colors:
	- Brage Skarp grønn	- #75FF8E - 117 255 142
	- Brage Lilla		- #EBDDFF - rgb(235, 221, 255) - hsl(265, 100%, 93%)
	- Brage Lys turkis	- #E5FFFF - 229 255 255
	- Brage Lys lilla	- #F4F2F9 - 244 242 249
	*/

	// FYI:
	// Mui will automagically calculate dark, light and
	// contrastText based on main color
	palette: {
		error: {
			main: "#E91B0C" //Make sure the resulting contrast is WCAG compatible.
		},
		primary: {
			main: "#00002B"
		},
		secondary: {
			main: "#DA0D2B"
		},
		text: {
			disabled: "rgba(0, 0, 0, 0.6)"
		},
		action: {
			selected: "hsla(265, 100%, 50%, 0.1)", // apprixamte "Brage Lilla" using opacity
			focus: "hsla(265, 100%, 50%, 0.06)",
			hover: "hsla(265, 100%, 50%, 0.06)"
		},
		status: {
			Paid: "#EBDDFF"
		}
	},
	alternativePalettes: {
		internal: {
			background: {
				default: "rgba(0,0,0,0)"
			},
			primary: {
				main: "#ab1a1a"
			},
			secondary: {
				main: "#00002b",
				light: "#a59bbf"
			},
			action: {
				active: "#ebddff",
				hover: "#eee8ff"
			}
		}
	},

	form: {
		statusInformation: {
			color: "orange"
		},
		applicationStatusSection: {
			headerBackground: { background: "#fafafad0" }
		}
	},

	shape: {
		borderRadius: 20
	},
	typography: {
		fontFamily: "Sharp Sans, sans-serif",
		fontFeatureSettings: "'ss01' 1"
	},

	overrides: {
		DployFormViews: {
			page: {
				padding: 12,
				overflow: "auto"
			}
		},
		MuiCssBaseline: {
			"@global": {
				"@font-face": SharpSans
			}
		},
		MuiAutocomplete: {
			paper: {
				fontFeatureSettings: "'ss01' 1"
			}
		},
		MuiToggleButton: {
			root: {
				fontFeatureSettings: "'ss01' 1",
				fontWeight: 400,
				"&.Mui-selected": {
					fontFeatureSettings: "'ss01' 1",
					fontWeight: 400
				}
			}
		},
		MuiChip: {
			root: {
				fontFeatureSettings: "'ss01' 1"
			}
		},
		MuiFormLabel: {
			root: {
				fontFeatureSettings: "'ss01' 1",
				color: brageStaticTextColorForAllBrandsAndThemes
			}
		},
		MuiInputBase: {
			root: {
				fontFeatureSettings: "'ss01' 1",
				color: brageStaticTextColorForAllBrandsAndThemes
			}
		},
		MuiButton: {
			root: {
				color: brageStaticTextColorForAllBrandsAndThemes
			}
		},
		MuiTableCell: {
			root: {
				fontFeatureSettings: "'ss01' 1"
			},
			head: {
				color: brageStaticTextColorForAllBrandsAndThemes,

				"& > div[data-rfd-draggable-context-id]": {
					justifyContent: "center"
				}
			},
			body: {
				color: brageStaticTextColorForAllBrandsAndThemes
			}
		},
		MuiTableRow: {
			root: {
				color: brageStaticTextColorForAllBrandsAndThemes
			}
		},
		MuiTypography: {
			h1: {
				fontFeatureSettings: "'ss01' 1"
			},
			h2: {
				fontFeatureSettings: "'ss01' 1"
			},
			h3: {
				fontFeatureSettings: "'ss01' 1"
			},
			h4: {
				fontFeatureSettings: "'ss01' 1"
			},
			h5: {
				fontFeatureSettings: "'ss01' 1"
			},
			h6: {
				fontFeatureSettings: "'ss01' 1"
			},
			subtitle2: {
				fontFeatureSettings: "'ss01' 1"
			},
			body1: {
				fontFeatureSettings: "'ss01' 1"
			},
			root: { color: brageStaticTextColorForAllBrandsAndThemes }
		},
		MuiStepLabel: {
			active: { color: brageStaticTextColorForAllBrandsAndThemes },
			label: { color: alpha(brageStaticTextColorForAllBrandsAndThemes, 0.8) }
		},
		DployFormSectionGroup: {
			marginLeft: {
				marginLeft: "56px"
			}
		}
	}
};

export const settings: TenantSettings = {
	allApplicationsColumns: [
		{
			id: "internalUser",
			hiddenInExpandable: false,
			hidden: false
		},
		{
			id: "field8",
			hiddenInExpandable: true,
			hidden: { smDown: true }
		},
		{
			id: "field17",
			hiddenInExpandable: true,
			hidden: { smDown: true }
		},
		{
			id: "field5",
			hiddenInExpandable: true,
			hidden: { smDown: true }
		},
		{
			id: "loanAmount",
			hiddenInExpandable: true,
			hidden: { smDown: true }
		},
		{
			id: "createdDate",
			hiddenInExpandable: true,
			hidden: true
		},
		{
			id: "salesPersonName",
			hiddenInExpandable: false,
			hidden: false
		},
		{
			id: "actions",
			hiddenInExpandable: true,
			hidden: true
		},
		{
			id: "productNameExternal",
			hiddenInExpandable: true,
			hidden: true
		},
		{
			id: "documentStatusNameExternal",
			hiddenInExpandable: true,
			hidden: true
		},
		{
			id: "paidDate",
			hiddenInExpandable: true,
			hidden: true
		},
		{
			id: "createdDate",
			hiddenInExpandable: true,
			hidden: true
		}
	],
	hideField8Column: true,
	hideField17Column: true,
	allApplicationsHideActions: [AllApplicationsActions.DisallowChangeRegNumber]
};

export const theme = createTheme(themeObject);
